import { Link } from "react-router-dom";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const STATUS_LABEL = { draft: "Draft", not_started: "To Do", rework_required: "Rework Required", in_progress: "In Progress", blocked: "Blocked",
  on_hold: "On Hold", completed: "Review", verified: "Completed", closed: "Closed", cancelled: "Cancelled" };
const STATUS_CLS = { draft: "tm-muted", not_started: "tm-todo", rework_required: "tm-warn", in_progress: "tm-progress", blocked: "tm-bad",
  on_hold: "tm-warn", completed: "tm-review", verified: "tm-done", closed: "tm-done", cancelled: "tm-muted" };
const PRIO_CLS = { critical: "tm-bad", high: "tm-warn", normal: "tm-progress", low: "tm-muted" };

export const StatusChip = ({ s, testid }) => <span className={`tm-chip ${STATUS_CLS[s] || "tm-muted"}`} data-testid={testid}>{STATUS_LABEL[s] || s}</span>;
export const PrioChip = ({ p }) => <span className={`tm-chip capitalize ${PRIO_CLS[p] || "tm-muted"}`}>{p}</span>;
export const DeptChip = ({ d }) => <span className="tm-chip tm-muted">{d}</span>;

export function Kpi({ label, value, sub, tone = "", to, testid }) {
  const inner = (
    <div className={`card-soft p-4 h-full transition-shadow hover:shadow-md ${to ? "cursor-pointer" : ""}`} data-testid={testid}>
      <p className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">{label}</p>
      <p className={`metric text-2xl sm:text-3xl font-bold mt-1 ${tone}`}>{value ?? "—"}</p>
      {sub && <p className="text-xs text-muted-foreground mt-1">{sub}</p>}
    </div>);
  return to ? <Link to={to} className="block h-full">{inner}</Link> : inner;
}

export function Sel({ value, onChange, placeholder, options, testid, allLabel }) {
  return (
    <Select value={value || "all"} onValueChange={(v) => onChange(v === "all" ? "" : v)}>
      <SelectTrigger className="h-9 w-auto min-w-[130px] bg-card text-xs" data-testid={testid}><SelectValue placeholder={placeholder} /></SelectTrigger>
      <SelectContent>
        <SelectItem value="all">{allLabel || placeholder}</SelectItem>
        {options.map((o) => (typeof o === "string" ? <SelectItem key={o} value={o} className="capitalize">{o.replace(/_/g, " ")}</SelectItem>
          : <SelectItem key={o.value} value={o.value}>{o.label}</SelectItem>))}
      </SelectContent>
    </Select>);
}

export function PageHead({ title, sub, right, testid }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-3" data-testid={testid}>
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">{title}</h1>
        {sub && <p className="text-sm text-muted-foreground mt-0.5">{sub}</p>}
      </div>
      {right && <div className="flex flex-wrap gap-2">{right}</div>}
    </div>);
}

export function Empty({ text, testid }) {
  return <div className="card-soft p-10 text-center text-sm text-muted-foreground" data-testid={testid}>{text}</div>;
}

export const errMsg = (e, fb = "Action failed") => (typeof e?.response?.data?.detail === "string" ? e.response.data.detail : fb);
